// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2po3Q","rootSuccess":"CompleteLink_rootSuccess__2FGci","rootFailure":"CompleteLink_rootFailure__3UKnM","isDisabled":"CompleteLink_isDisabled__2tYtY"};